export default __webpack_public_path__ + "static/media/i074jk.e92a9ec8.webp";